import type { RouteExpense } from '../../../store/api/financeApi';
import { normalizeRouteExpenseStatus } from '../constants/routeExpenseStatus';
import { routeExpenseTypeLabel } from '../constants/routeExpenseTypes';

export type RouteExpenseSummary = {
  draft: number;
  pendingApproval: number;
  confirmed: number;
  rejected: number;
  total: number;
};

export type RouteExpenseTimelineEvent = {
  id: string;
  at: string;
  label: string;
  expenseId: number;
  typeLabel: string;
};

export function summarizeRouteExpenses(expenses: RouteExpense[]): RouteExpenseSummary {
  let draft = 0;
  let confirmed = 0;
  let rejected = 0;
  for (const e of expenses) {
    const s = normalizeRouteExpenseStatus(e.status);
    if (s === 'CONFIRMED') confirmed += 1;
    else if (s === 'REJECTED') rejected += 1;
    else draft += 1;
  }
  return {
    draft,
    pendingApproval: draft,
    confirmed,
    rejected,
    total: expenses.length
  };
}

export function countDraftExpensesForReadiness(expenses: RouteExpense[]): number {
  return expenses.filter((e) => normalizeRouteExpenseStatus(e.status) === 'DRAFT').length;
}

export function buildRouteExpenseTimeline(expenses: RouteExpense[]): RouteExpenseTimelineEvent[] {
  const events: RouteExpenseTimelineEvent[] = [];
  for (const e of expenses) {
    const status = normalizeRouteExpenseStatus(e.status);
    const typeLabel = routeExpenseTypeLabel(e.type);
    const createdAt = e.createdAt ?? e.expenseDate;
    events.push({
      id: `created-${e.id}`,
      expenseId: e.id,
      at: createdAt,
      label: 'Расход создан',
      typeLabel
    });
    if (status === 'DRAFT') {
      events.push({
        id: `pending-${e.id}`,
        expenseId: e.id,
        at: createdAt,
        label: 'Отправлен бухгалтеру на подтверждение',
        typeLabel
      });
    }
    if (status === 'CONFIRMED' && e.confirmedAt) {
      events.push({
        id: `confirmed-${e.id}`,
        expenseId: e.id,
        at: e.confirmedAt,
        label: 'Подтверждён бухгалтерией',
        typeLabel
      });
    }
    if (status === 'REJECTED') {
      events.push({
        id: `rejected-${e.id}`,
        expenseId: e.id,
        at: e.confirmedAt ?? createdAt,
        label: 'Отклонён',
        typeLabel
      });
    }
  }
  return events.sort((a, b) => new Date(b.at).getTime() - new Date(a.at).getTime());
}
